/** "Cmd" on Apple platforms, "Ctrl" elsewhere — key hints are spelled out, never glyphs. */
export const MOD_KEY =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? 'Cmd' : 'Ctrl'
